import { render, staticRenderFns } from "./RightChart1.vue?vue&type=template&id=0bd721ec&scoped=true&"
import script from "./RightChart1.vue?vue&type=script&lang=js&"
export * from "./RightChart1.vue?vue&type=script&lang=js&"
import style0 from "./RightChart1.vue?vue&type=style&index=0&id=0bd721ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd721ec",
  null
  
)

export default component.exports